import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Button, Paper, Stack, Typography } from '@mui/material';

const glassPanelSx = {
  backgroundColor: 'rgba(255,255,255,0.72)',
  backdropFilter: 'blur(14px)',
  borderRadius: 3,
  boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
};

const navItems = [
  { label: 'Overview', to: '/admin' },
  { label: 'Artists', to: '/admin/artists' },
  { label: 'Hosts', to: '/admin/hosts' },
  { label: 'Buyers', to: '/admin/buyers' },
  { label: 'Artworks', to: '/admin/artworks' },
];

export default function AdminWorkspaceNav({ title = 'Admin Workspace', subtitle }) {
  const location = useLocation();

  return (
    <Paper sx={{ ...glassPanelSx, p: 2.5 }}>
      <Stack spacing={2}>
        <div>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : null}
        </div>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} flexWrap="wrap">
          {navItems.map((item) => {
            const isActive =
              item.to === '/admin'
                ? location.pathname === '/admin'
                : location.pathname.startsWith(item.to);

            return (
              <Button
                key={item.to}
                component={RouterLink}
                to={item.to}
                variant={isActive ? 'contained' : 'outlined'}
              >
                {item.label}
              </Button>
            );
          })}
        </Stack>
      </Stack>
    </Paper>
  );
}
